<template>
    <div class="icon-session">
        <div
            v-for="(ic, index) in icons"
            :key="index"
            v-if="ic === name"
            v-html="require(`!!html-loader!@icons/sp/intro/${ic}.svg`).default"
            class="fill-current"
        ></div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                icons: [
                'intro-cognitive-restructuring-catching-ants',
                'intro-cognitive-restructuring-cbt-triangle',
                'intro-cognitive-restructuring-defusion-techniques',
                'intro-cognitive-restructuring-real-odds',
                'intro-cognitive-restructuring-restructuring-strategies',
                'intro-cognitive-restructuring-thinking-traps',
                'intro-goal-setting-closing',
                'intro-goal-setting-pacing',
                'intro-goal-setting-pleasant-activities',
                'intro-goal-setting-smart-goals',
                'intro-pain-education-intro',
                'intro-pain-education-opioid',
                'intro-pain-education-surgery',
                'intro-relaxation-grounding-tools',
                'intro-relaxation-mental-exercises',
                'intro-sleep-cog-restructuring',
                'intro-sleep-hygiene-assessment',
                'intro-sleep-other-resources',
                'intro-welcome-self-assessment',
                ]
            }
        },
        props: {
            name: String,
        },
        mounted() {

        },
    }
</script>